import { type FC } from 'react';
import { useStyleContextState } from '../../../../../ReactSharedScripts/modules/styleContext';
import { SvgComponentProps } from '../../../../../ReactSharedScripts/components/Icons/types';
import classes from '../styles/index.module.css';
import RouteLink from '../../../../../ReactSharedScripts/components/RouteLink';

type ToolNavigationCollapsedLinkIconProps = {
	isActive: boolean;
	title: string;
	url?: string;
	icon: FC<SvgComponentProps>;
	onClick?: () => void;
};

export const ToolNavigationCollapsedLink: FC<ToolNavigationCollapsedLinkIconProps> = ({
	isActive,
	title,
	url,
	icon: ToolNavigationIcon,
	onClick,
}) => {
	const { mainColor } = useStyleContextState();

	const style = isActive
		? {
			color: mainColor,
			borderColor: mainColor,
			fill: mainColor,
		}
		: undefined;

	return (
		<RouteLink
			className={classes.toolNavigation__collapsedLink}
			href={url}
			title={title}
			style={style}
			hasColor={isActive}
			data-tool-navigation-module-name={url}
			onClick={onClick}
			useDirty
		>
			{ToolNavigationIcon && (
				<ToolNavigationIcon
					className={classes.toolNavigation__collapsedIcon}
					style={style}
				/>
			)}
		</RouteLink>
	);
};
